import type { PropsWithChildren } from "react";
import type { Props } from "./FileContainersListContext";
import { FileContainersListContext } from "./FileContainersListContext";

export const FileContainersListContextProvider = ({ children, ...contextValue }: PropsWithChildren<Props>) => (
  <FileContainersListContext value={contextValue}>{children}</FileContainersListContext>
);
